export default {
    'this-specialty': 'this specialty',
    'add-new-specialty': 'Add new specialty',
    'edit-specialty': 'Edit specialty'
}